import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Box, Typography } from '@lyearn/ui';
import { Link } from '@/components/Link';
import { GeoLocation } from '@/types/schema';

import { getGeoLocationMapUrl } from '../utils';
import { viewMapButtonStyles } from './styles';

function ViewMapButton({
  geoLocation,
  className = 'absolute bottom-8 end-8',
}: {
  geoLocation: GeoLocation;
  className?: string;
}) {
  const { t } = useTranslation();
  const locationUrl = getGeoLocationMapUrl(geoLocation);

  if (!locationUrl) {
    return null;
  }

  return (
    <Link target="_blank" to={{ pathname: locationUrl }}>
      <Box className={cn('bg-overlay px-8 py-4', viewMapButtonStyles, className)}>
        <Typography color="text-text-white" variant="body-short-03">
          {t('Events:Editor.ViewMap')}
        </Typography>
      </Box>
    </Link>
  );
}

export default ViewMapButton;
